import React, { useContext } from "react";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { DropdownItem, DropdownMenu, DropdownToggle, Input, Label, Col, UncontrolledDropdown, Form, FormFeedback, Row } from "reactstrap";
import PropTypes from 'prop-types';
import { useFormik } from "formik";
import Select from 'react-select';
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';
import { us_states } from "common/data/us_states"
import { getPrimaryButtonClass } from "helpers/sf_utils";
import ReactTextareaAutosize from "react-textarea-autosize";
import { useState } from "react";

const EditAddressDropdown = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [fieldAddress, setFieldInput] = React.useState(props.Address);
    const [fieldState, setFieldState] = React.useState(props.State);
    const [fieldCity, setFieldCity] = React.useState(props.City);
    const [fieldZipCode, setFieldZipCode] = React.useState(props.ZipCode);
    const [isEditable, setIsEditable] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [isMouseDown, setIsMouseDown] = useState(false)


    const handleOnClickClose = () => {
        setIsOpen(false);
    };

    const toggle = () => setIsOpen(!isOpen);

    if (isReadOnly) {
        return (
            <p className="mb-0 fsnormal text-black me-1">
                {props?.Address ? props?.Address + ', ' : ''}
                {props?.City ? props?.City + ', ' : ''}
                {props?.State ? props?.State + ', ' : ''}
                {props?.ZipCode ? props?.ZipCode : ''}
            </p>
        );
    }

    let state_names = []
    us_states.map(e => {
        state_names.push({ label: e.isocode, value: e.name })
    })

    const optionGroupStates = [
        {
            label: "Select State",
            options: state_names,
        },
    ]

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            address: fieldAddress || '',
            state: fieldState ? optionGroupStates[0]?.options?.find(e => e.label == fieldState) : '',
            city: fieldCity || '',
            zip: fieldZipCode || '',
        },
        validationSchema: Yup.object({
            address: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_ADDRESS)
                .min(3)
                .matches(
                    CONSTANTS.addressRegExp,
                    CONSTANTS.STR_INVALID_ADDRESS
                ),
            city: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_CITY)
                .matches(
                    CONSTANTS.cityRegExp,
                    CONSTANTS.STR_INVALID_CITY
                )
                .min(2),
            state: Yup.object().shape({
                label: Yup.string().required(),
                value: Yup.string().required(),
            }),
            zip: Yup.string()
                .required(CONSTANTS.STR_REQUIRED_ZIP)
                .matches(CONSTANTS.zipcodeRegExp, "Please enter a valid zip code"),
        }),
        onSubmit: (values) => {
            props?.onSaveAddressClick({
                ...values,
                state: values.state.label,
            });
            toggle()
        },
    });

    return (
        <React.Fragment>
            <UncontrolledDropdown isOpen={isOpen}
             onToggle={(event, isOpen) => {
                if(!isMouseDown && isOpen) {
                    toggle()
                } else if (isMouseDown && isOpen) {
                    setIsMouseDown(false);
                }
                else if (!isOpen) {
                    setIsMouseDown(false);
                    setIsOpen(true)
                }}}
             onMouseDown={(e) => setIsMouseDown(true)}
             onMouseUp={(e) => setIsMouseDown(false)}>
                <DropdownToggle
                    href="#"
                    className='nav-link py-0 px-0'
                    tag="i"
                    direction="up"
                >
                    <div 
                    className="d-flex"
                    onMouseEnter={(e) => {
                        setIsEditable(true);
                    }}
                        onMouseLeave={(e) => {
                            setIsEditable(false);
                        }}>
                            <p className="mb-0 fsnormal text-black me-1"
                                onMouseEnter={(e) => {
                                    setIsEditable(true);
                                }}
                                onMouseLeave={(e) => {
                                    setIsEditable(false);
                                }}
                            >
                                {props?.Address ? props?.Address + ', ' : ''}
                                {props?.City ? props?.City + ', ' : ''}
                                {props?.State ? props?.State + ', ' : ''}
                                {props?.ZipCode ? props?.ZipCode : ''}
                            </p>
                        {isEditable === true ?
                            <i
                                className="font-size-13 mdi mdi-pencil text-success"
                            /> :
                            <div className="edit-hover-class">
                                <a ><i
                                    className="font-size-13 mdi mdi-pencil text-success"
                                />
                                </a>
                            </div>
                        }
                    </div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-start">
                    <DropdownItem className="font-weight-semibold">Address</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem text>
                        <Form
                            onSubmit={e => {
                                e.preventDefault();
                                validation.handleSubmit()
                                return false
                            }}
                            className='sf-box-w'
                        >
                            <div className="d-flex flex-column">
                                <Row>
                                    <Col sm='12' className="mb-2">
                                        <Label>Address</Label>
                                        <ReactTextareaAutosize
                                            type='text'
                                            className="form-control"
                                            name="address"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.address || ''}
                                            invalid={
                                                !!(validation.touched.address
                                                    && validation.errors.address)
                                            }
                                        />
                                        {validation.touched.address
                                            && validation.errors.address ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.address}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>
                                    <Col sm='12' className="mb-2">
                                        <Label>City</Label>
                                            <Input
                                                type='text'
                                                className="form-control"
                                                name="city"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.city || ''}
                                                invalid={
                                                    !!(validation.touched.city
                                                        && validation.errors.city)
                                                }
                                            />
                                            {validation.touched.city
                                                && validation.errors.city ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.city}
                                                </FormFeedback>
                                            ) : null}
                                    </Col>
                                    <Col className="d-flex align-items-top">
                                        <Col sm='6' className="pe-1">
                                            <Label>State</Label>
                                            <Select
                                                options={optionGroupStates}
                                                maxMenuHeight="200px"
                                                onChange={(selectedOption) => {
                                                    const event = {
                                                        target: {
                                                            name: 'state',
                                                            value: selectedOption,
                                                        },
                                                    };
                                                    validation.handleChange(event);
                                                }}
                                                onBlur={() => {
                                                    validation.handleBlur({
                                                        target: { name: 'state' },
                                                    });
                                                }}
                                                value={validation.values.state || null}
                                                invalid={
                                                    !!(validation.touched.state
                                                        && validation.errors.state)
                                                }
                                            />
                                            {validation.touched.state
                                                && validation.errors.state ? (
                                                <span className="text-danger">
                                                    {CONSTANTS.STR_REQUIRED_FIELD}
                                                </span>
                                            ) : null}
                                        </Col>
                                        <Col sm='6' className="ps-1">
                                            <Label>Zip Code</Label>
                                            <Input
                                                name="zip"
                                                type="zip"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.zip || ""}
                                                invalid={
                                                    validation.touched.zip &&
                                                        validation.errors.zip
                                                        ? true
                                                        : false
                                                }
                                            ></Input>
                                            {validation.touched.zip &&
                                                validation.errors.zip ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.zip}
                                                </FormFeedback>
                                            ) : null}
                                        </Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" lg="12">
                                        <div className="text-end mt-3">
                                            <button
                                                type="submit"
                                                className={`btn ${getPrimaryButtonClass()} ms-2`}
                                                name="submit"
                                                onClick={() => validation.handleSubmit()}
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-light ms-2"
                                                onClick={handleOnClickClose}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </React.Fragment>
    )
}

EditAddressDropdown.propTypes = {
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    onSaveAddressClick: PropTypes.func
}

export default EditAddressDropdown